import { Switch } from "@blueprintjs/core";
import {
    CustomUpgrade,
    useCustomUpgrades
} from "in_queue/contexts/CustomUpgradesContext";
import { useCustomUpgradesStatus } from "in_queue/hooks/useCustomUpgradesStatus";
import { useEffect, useRef, useState } from "react";
import { AddCustomUpgradeButton } from "./AddCustomUpgradeButton";
import { CUSTOM_UPGRADE_STATUS_ARCHIVED } from "./customUpgradeConstants";
import { CustomUpgradeDialog } from "./CustomUpgradeDialog";
import css from "./CustomUpgradesSection.module.scss";
import { CustomUpgradesTable } from "./CustomUpgradesTable";

export const CustomUpgradesSection: React.FC = () => {
    const customUpgrades = useCustomUpgrades();
    const status = useCustomUpgradesStatus();
    const [showArchived, setShowArchived] = useState(false);
    const [openUpgrade, setOpenUpgrade] = useState<CustomUpgrade | null>(null);
    const sectionRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (showArchived) {
            sectionRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "end"
            });
        }
    }, [showArchived]);

    const allUpgrades = customUpgrades === "loading" ? [] : customUpgrades;

    const numArchived = allUpgrades.filter(
        (u) => u.status === CUSTOM_UPGRADE_STATUS_ARCHIVED
    ).length;

    const visibleUpgrades = showArchived
        ? allUpgrades
        : allUpgrades.filter(
              (u) => u.status !== CUSTOM_UPGRADE_STATUS_ARCHIVED
          );

    if (status === "hidden") return null;

    return (
        <div ref={sectionRef} className={css["CustomUpgradesSection"]}>
            <CustomUpgradesTable
                upgrades={visibleUpgrades}
                loading={customUpgrades === "loading"}
                onRowClick={setOpenUpgrade}
            />
            <div className={css["CustomUpgradesSection-footer"]}>
                {numArchived > 0 && (
                    <Switch
                        className={css["CustomUpgradesSection-footer-toggle"]}
                        checked={showArchived}
                        label={`Show archived (${numArchived})`}
                        onChange={() => setShowArchived(!showArchived)}
                    />
                )}
                <div className={css["CustomUpgradesSection-footer-action"]}>
                    <AddCustomUpgradeButton />
                </div>
            </div>
            {openUpgrade && (
                <CustomUpgradeDialog
                    isOpen
                    onClose={() => setOpenUpgrade(null)}
                    upgrade={openUpgrade}
                />
            )}
        </div>
    );
};
